import { useState, useEffect, useContext } from 'react';
import Context from '../../context';
import './Detail.scss';
import { linksAndNewLinesToHtml } from '../../helpers';
import { useLocation, useNavigate } from "react-router-dom";

const Detail = ({ type, data, setDocumentViewerData }) => {
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [video, setVideo] = useState(null);
  const [buttons, setButtons] = useState(null);
  const [description, setDescription] = useState(null);

  const { itin, icons, viewMode } = useContext(Context);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setBackgroundImage(data.backgroundNode?.file?.httpsUrl ?? itin?.photoNode?.file?.httpsUrl);
    setVideo(data?.videoNode?.file?.httpsUrl || null)
    setDescription(data.description);

    if (data?.menu?.length) {
      const expandedMenu = data.menu.map(item => {
        const doc = itin.documents.find(doc => doc.id === item.segueId);
        return {
          ...item,
          segueNode: doc || null
        };
      });
      setButtons(expandedMenu);
    }
  }, [data, itin.documents, itin?.photoNode?.file?.httpsUrl, viewMode]);

  const renderTitle = () => {
    if (!data.title || viewMode !== 'desktop') return null;
    return (
      <div className="title">{data.title}</div>
    );
  };

  const renderVideo = () => {
    if (!video) return null;
    return (
      <video
        controls
        preload="metadata"
      >
        <source src={video} />
        <p>
          Your browser doesn't support HTML5 video. Here is a <a href={video}>link to the video</a> instead.
        </p>
      </video>
    );
  };

  const renderDescription = () => {
    return (
      <div className="description-container">
        <div className="empty" />
        <div className="description" dangerouslySetInnerHTML={{ __html: linksAndNewLinesToHtml(description || '') }}/>
        {/*<div className="description" dangerouslySetInnerHTML={{ __html: linksAndNewLinesToHtml(`${description} ${description} ${description} ${description}`) }}/>*/}
      </div>
    );
  };

  const handleClick = (doc, event) => {
    event.preventDefault();
    setDocumentViewerData(doc);
    navigate(`${location.pathname}/view/${doc.id}`);
  };

  const renderButtons = () => {
    if (!buttons) return null;
    return (
      <ul className="buttons">
        {
          buttons.map((x, i) => (
            <li key={i}>
              {
                (x.segueNode?.type === "file" || x.segueNode?.type === "bundle") ? (
                    <button
                      onClick={(e) => handleClick(x.segueNode, e)}
                    >
                      <img src={icons[x.iconId]} alt='' />
                      {x.label}
                    </button>
                ) : (
                  <a
                    href={x.segueNode.remoteUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={icons[x.iconId]} alt='' />
                    <span>{x.label}</span>
                  </a>
                )
              }
            </li>
          ))
        }
      </ul>
    );
  };

  return (
    <div
      className={`detail detail-${type} ${backgroundImage ? 'has-background-image' : ''} ${video ? 'has-video' : ''} ${buttons ? 'has-buttons' : ''} ${description ? 'has-description' : ''}`}
      style={{ background: backgroundImage ? `url("${backgroundImage}")` : null }}
    >
      <div className="shadow" />
      <div className="inner-content">
        {
            <>
              { renderTitle() }
              { renderVideo() }
              { renderDescription() }
              { renderButtons() }
              {/*<div className="bottom-whitespace" />*/}
            </>
        }
      </div>
    </div>
  );
};

export default Detail;